import React from 'react';

const PageLoader = () => {
    return (
        <div className={`w-full h-screen flex items-center justify-center bg-white`}>
            <img
                src='https://images.halalfull.com/assets/img/logo.svg'
                alt='Loading...'
                className='w-20 h-20'
            />
        </div>
    );
};

export default PageLoader;
